import { FontAwesomeIcon as FA } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

const Views = ({ current = "list" }) => {
  const navigate = useNavigate();

  // Function to set the view and update settings: 'list', 'box', or 'console'
  const setView = (view) => {
    if (view === "console") {
      navigate("/old/presentation_server/console");
    } else {
      navigate(`/old/presentation_server/forms/${view}`);
    }
  };

  return (
    <>
      <ul className="views">
        <li>
          <div
            className={`icon-list ${current === "list" ? "active" : ""}`}
            title="LIST VIEW"
            onClick={() => setView("list")}
            data-toggle="tooltip"
            data-placement="top"
          ></div>
        </li>
        <li>
          <div
            className={`icon-boxes ${current === "box" ? "active" : ""}`}
            title="BOX VIEW"
            onClick={() => setView("box")}
            data-toggle="tooltip"
            data-placement="top"
          ></div>
        </li>
        <li>
          <div
            title="CONSOLE VIEW"
            onClick={() => setView("console")}
            data-toggle="tooltip"
            data-placement="top"
            style={{
              display: "flex",
            }}
          >
            <FA
              icon="laptop"
              color={`${current === "console" ? "#ff5e54" : "#a8a5a1"}`}
              fontSize={"0.89em"}
            />
          </div>
        </li>
      </ul>
    </>
  );
};

export default Views;
